import { TabPanel } from "@mui/lab";
import type { Breakpoint } from "@mui/material";
import { Container } from "@mui/material";
import type { PropsWithChildren } from "react";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";

interface Props {
  value: string;
  containerWidth?: Breakpoint;
  fillHeight?: boolean;
}

const PageTabPanel = ({ value, containerWidth, fillHeight, children }: PropsWithChildren<Props>) => (
  <TabPanel value={value} sx={{ flex: 1, minHeight: 0, height: "100%", p: 0 }}>
    <ScrollableFlexContainer sx={{ height: "100%" }}>
      <Container
        maxWidth={containerWidth ?? false}
        sx={{ display: "flex", flexDirection: "column", minHeight: "100%", height: fillHeight ? "100%" : undefined }}
      >
        {children}
      </Container>
    </ScrollableFlexContainer>
  </TabPanel>
);

export default PageTabPanel;
